import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { TenantDto } from '@picflow/types';
import { catchError, from, map, of } from 'rxjs';
import { GalleryService } from '../../services/gallery.service';

export const publicGalleryPageDescriptionResolver: ResolveFn<string> = route => {
  const galleryService = inject(GalleryService);

  return from(galleryService.getPublicGalleryFromSnapshot(route, { isPublic: true })).pipe(
    map(gallery => {
      if (!gallery) return;
      const tenantName = (gallery.tenant as TenantDto)?.name;
      if (!tenantName) return;
      return `Photo Gallery by ${tenantName}`;
    }),
    catchError(() => of(undefined as string))
  );
};
